import useQuery from './useQuery'
import axios from 'axios'

const fetchGlobalConfigs = () => axios.get(`/v1/parameters.json`).then(res => res.data)

const useGlobalConfigs = () => useQuery(['global_configs'], fetchGlobalConfigs)
export default useGlobalConfigs
